import { Theme } from '@mui/material';

const overrides: Theme['components'] = {
  MuiSelect: {
    defaultProps: {
      MenuProps: { disableScrollLock: true },
    },
  },
};

export default overrides;
